import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component (and the heavy AlertsList screen it
// renders) lives in `index.lazy.tsx`.
export const Route = createFileRoute("/app/alerts/")({});
